import { useNavigate } from "react-router-dom";
import "./style.scss";

export const TitleBar = ({ title, showIcon = false, isRealTime = false  }) => {
  const navigate = useNavigate();

  return (
    <div
      className={`titleBarContainer ${isRealTime ? "realTimeTitleBar" : ""}`}
    >
      <div className="titleBarItem d-flex align-items-center gap-4">
        {showIcon && (
          <i
            className="ri-arrow-left-line cursor-pointer"
            style={{ color: "#0F62FE", fontSize: "24px" }}
            onClick={() => navigate(-1)}
          ></i>
        )}
        <h2 className="titleBarText">{title}</h2>
      </div>
    </div>
  );
};
